var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExitButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.55886 0.438337C2.97304 -0.147414 2.02324 -0.147414 1.43741 0.438337C0.851591 1.02409 0.851591 1.97378 1.43741 2.55953L6.87857 8.00002L1.43741 13.4405C0.851591 14.0263 0.851591 14.976 1.43741 15.5617C2.02324 16.1475 2.97304 16.1475 3.55886 15.5617L9.00002 10.1212L14.4409 15.5615C15.0268 16.1472 15.9766 16.1472 16.5624 15.5615C17.1482 14.9757 17.1482 14.026 16.5624 13.4403L11.1215 8.00002L16.5624 2.55977C17.1482 1.97402 17.1482 1.02433 16.5624 0.438576C15.9766 -0.147175 15.0268 -0.147175 14.4409 0.438576L9.00002 5.87883L3.55886 0.438337Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitButton);
export default __webpack_public_path__ + "static/media/exitButton.cfb0a7fcd3674e96c9be762676f235a1.svg";
export { ForwardRef as ReactComponent };